module.exports = __webpack_public_path__ + "static/media/pos.b2b53ba2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pos.jpeg
// module id = 124
// module chunks = 0